'use strict';

angular.module('controllers').controller('userAreaCtrl', function ($window, $scope) {

	});

